import { AsyncPipe, NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';

import { DotCmsUveFacade } from '../../../facades/dot-cms-uve.facade';
import { VideoContentlet } from '../../../models/dot-cms-uve-contentlet.model';
import { tryProcessVideo } from '../../../utils/dot-cms-uve-utils';

@Component({
  selector: 'custom-dot-cms-uve-vimeo-video',
  templateUrl: './dot-cms-uve-vimeo-video.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./dot-cms-uve-vimeo-video.component.scss'],
  imports: [NgClass, NgStyle, AsyncPipe],
})
export class DotCmsUveVimeoVideoComponent {
  contentlet = input.required<VideoContentlet>();
  private dotCmsUveFacade = inject(DotCmsUveFacade);
  constructor(private sanitizer: DomSanitizer) {}

  getVideoHeight$(contentlet: VideoContentlet): Observable<string> {
    return this.dotCmsUveFacade.getVideoHeight(contentlet);
  }

  iframeVideoUrl(contentlet: VideoContentlet) {
    return tryProcessVideo(contentlet, this.sanitizer);
  }
  getVideoClasses(contentlet: VideoContentlet) {
    return this.dotCmsUveFacade.getVideoClasses(contentlet);
  }
}
